import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const AutoSchedulePage = lazy(() => import('@pages/autoschedule/AutoSchedulePage'));

// Route Component using PageWrapper approach
const AutoScheduleRouteContainer = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('scheduling-auto-schedule-page-title')}>
        <AutoSchedulePage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default { AutoScheduleRouteContainer };
